import { PanelType } from "../enum/PanelType";

export const PanelTypesNames: { [key in PanelType]: string } = {
  [PanelType.OuterPanel]: "Seiten",
  [PanelType.TrayPanel]: "Innenwände",
  [PanelType.RollerBoard]: "Rollbrett",
  [PanelType.SlideRail]: "Rutschleiste",
  [PanelType.Underlay]: "Unterleghölzer",
};
